// @ts-nocheck
import Checkbox from "@insite/mobius/Checkbox";
import React from "react";

// itentifier is only neccessary if the itemText is not unique
interface Props {
    identifier?: string;
    itemText: string;
    selectedItems: string[];
    toggleItem: (item: string) => void;
}
const CheckboxModalPicker: React.FC<Props> = ({ itemText, selectedItems, toggleItem, identifier }) => {
    const isChecked = () => {
        return selectedItems.includes(identifier || itemText);
    };
    return (
        <>
            <Checkbox key={itemText} checked={isChecked()} onChange={() => toggleItem(identifier || itemText)}>
                {itemText}
            </Checkbox>
        </>
    );
};

export default CheckboxModalPicker;
